<h1 *header="existing ? 'Update Account' : 'Create Account'; d9: '#block-pac-theme-pagetitle h1.title'; let title"
  class="page-header">{{ title }}</h1>
<form (ngSubmit)="OnSubmit(individual)" [formGroup]="form">
  <alert *ngIf="!existing" type="info">
    <p>If you have used our site before, please <a href="/user/login">log in</a>, instead of creating a new account. <a
        href="/user/password">Forgot your password?</a>
      Not sure which email you used? Call us for assistance at <a [href]="'tel:' + settings.site_phone">{{
        settings.site_phone }}</a>.</p>
  </alert>

  <fieldset bsMigration [bs3Class]="['panel-default']" [bs4Class]="['mb-3']" class="panel">
    <legend bsMigration class="panel-heading">Email</legend>
    <div bsMigration class="panel-body">
      <div class="form-group">
        <label for="input-password">Email Address</label>
        <div class="input-group">
          <ng-container bsMigrationPicker [bs3]="updateEmailBs3" [bs4]="updateEmailBs4">
            <ng-template #updateEmailBs4>
              <input type="text" readonly class="form-control" [value]="individual.eml_address">
              <a class="btn btn-info" [href]="existing ? '/user' : '/signup/email'">Update Email</a>
            </ng-template>
            <ng-template #updateEmailBs3>
              <p class="form-control-static">{{ individual.eml_address }}</p>
              <span class="input-group-btn">
                <a class="btn btn-info" [href]="existing ? '/user' : '/signup/email'">Update Email</a>
              </span>
            </ng-template>
          </ng-container>

        </div>
      </div>
    </div>
  </fieldset>

  <app-password *ngIf="!existing" [individual]="individual" [isSaving]="isSaving" [form]="form" [OnSave]="OnSave">
  </app-password>
  <app-individual [individual]="individual" [isSaving]="isSaving" [existing]="existing" [form]="form" [OnSave]="OnSave">
  </app-individual>
  <app-demographics *ngIf="!existing" [individual]="individual" [isSaving]="isSaving" [existing]="existing"
    [form]="form" [OnSave]="OnSave"></app-demographics>
  <app-recaptcha *ngIf="!existing" [individual]="individual" [isSaving]="isSaving" [existing]="existing" [form]="form">
  </app-recaptcha>

  <alert *ngIf="!existing" type="info">
    <p>If you have used our site before, please <a href="/user/login">log in</a>, instead of creating a new account. <a
        href="/user/password">Forgot your password?</a>
      Not sure which email you used? Call us for assistance at <a [href]="'tel:' + settings.site_phone">{{
        settings.site_phone }}</a>.</p>
  </alert>

  <button type="submit" class="btn btn-primary btn-lg" [disabled]="!form.valid || isSaving">{{ existing ? 'Update
    Account' : 'Create Account' }}</button>
  <button bsMigration type="button" class="btn btn-default btn-lg" *ngIf="CanSkip$ | async"
    (click)="skip()">Continue</button>
</form>